import { pythonApiClient, pythonPublicClient } from "./python-http-client.service";
import { CheckoutResult, PublicStore, StoreProduct, StoreSettings, WebsiteCheckout } from "../models/storefront.model";
const owner = (id: string) => `/api/ecomm/businesses/${encodeURIComponent(id)}`;
const store = (slug: string) => `/api/stores/${encodeURIComponent(slug)}`;
export interface ProductImportReport {
  productCount: number; createdCount?: number; updatedCount?: number; duplicateRows?: number; reviewCount?: number;
  warnings?: { sku: string; name: string; packs: { pack: string; reason: string; prices: string[]; rows?: number[]; retainedPrice?: string }[] }[];
}
export const storefrontApi = {
  settings: async (id: string) => (await pythonApiClient.get<StoreSettings>(`${owner(id)}/storefront`)).data,
  saveSettings: async (id: string, { url, ...data }: StoreSettings) => (await pythonApiClient.put<StoreSettings>(`${owner(id)}/storefront`, data)).data,
  uploadStoreLogo: async (id: string, file: File) => {
    const data = new FormData(); data.append("file", file);
    return (await pythonApiClient.post<{ imageUrl: string; filename: string }>(`${owner(id)}/storefront/logo`, data)).data;
  },
  products: async (id: string) => (await pythonApiClient.get<{ items: StoreProduct[] }>(`${owner(id)}/products`)).data.items,
  latestImport: async (id: string) => (await pythonApiClient.get<ProductImportReport | null>(`${owner(id)}/products/import-report`)).data,
  uploadProductPhoto: async (id: string, file: File) => {
    const data = new FormData(); data.append("file", file);
    return (await pythonApiClient.post<{ imageUrl: string; filename: string }>(`${owner(id)}/product-photos`, data)).data;
  },
  saveProduct: async (id: string, { id: productId, ...data }: StoreProduct) => productId
    ? (await pythonApiClient.put<StoreProduct>(`${owner(id)}/products/${encodeURIComponent(productId)}`, data)).data
    : (await pythonApiClient.post<StoreProduct>(`${owner(id)}/products`, data)).data,
  importProducts: async (id: string, file: File) => {
    const data = new FormData(); data.append("file", file);
    return (await pythonApiClient.post<ProductImportReport>(`${owner(id)}/products/import`, data, { headers: { "Content-Type": "multipart/form-data" } })).data;
  },
  publicStore: async (slug: string) => (await pythonPublicClient.get<PublicStore>(store(slug))).data,
  checkout: async (slug: string, data: WebsiteCheckout) => (await pythonPublicClient.post<CheckoutResult>(`${store(slug)}/checkout`, data)).data,
};
